var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6663 1.99935H13.333C14.0663 1.99935 14.6663 2.59935 14.6663 3.33268V13.9993C14.6663 14.7327 14.0663 15.3327 13.333 15.3327H2.66634C1.93301 15.3327 1.33301 14.7327 1.33301 13.9993V3.33268C1.33301 2.59935 1.93301 1.99935 2.66634 1.99935H3.33301V1.33268C3.33301 0.966016 3.63301 0.666016 3.99967 0.666016C4.36634 0.666016 4.66634 0.966016 4.66634 1.33268V1.99935H11.333V1.33268C11.333 0.966016 11.633 0.666016 11.9997 0.666016C12.3663 0.666016 12.6663 0.966016 12.6663 1.33268V1.99935ZM3.33301 13.9993H12.6663C13.033 13.9993 13.333 13.6993 13.333 13.3327V5.33268H2.66634V13.3327C2.66634 13.6993 2.96634 13.9993 3.33301 13.9993Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.686506a261f8601128d83ee0000a16dc.svg";
export { ForwardRef as ReactComponent };